import { inject } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest, HttpStatusCode } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';

export function authInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const router = inject(Router);
  const route = inject(ActivatedRoute);

  return next(req).pipe(
    tap({
        error: (err: Error) => {
          if (err instanceof HttpErrorResponse) {
            if ([HttpStatusCode.Forbidden, HttpStatusCode.Unauthorized].includes(err.status)) {
              return router.navigate(['/landing/login'], {
                relativeTo: route,
              });
            }
          }

          return Promise.resolve(true);
        },
      },
    ),
  );
}
